import React, { useEffect } from 'react';
import { Routes, Route, useNavigate, useLocation, Navigate } from 'react-router-dom';
import CardContainer from './CardContainer';
import AboutPage from '../components/AboutPage';
import ProjectsPage from '../components/ProjectsPage';
import WritingsPage from '../components/WritingsPage';
import ContactsPage from '../components/ContactsPage';
import { Svg1, Svg2, Svg3, Svg4} from '../components/Svgs';
import '../styles/App.css';
import '../styles/CvDownload.css';

const ROUTE_TO_CARD = {
  '/about': 'about',
  '/projects': 'projects',
  '/stats': 'projects',
  '/writings': 'writings',
  '/contact': 'contact',
};

const getActiveCard = (pathname) => {
  if (pathname.startsWith('/projects/')) {
    return 'projects';
  }
  return ROUTE_TO_CARD[pathname] ?? null;
};

const App = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const activeCard = getActiveCard(location.pathname);
  const isCardOpen = activeCard !== null;

  useEffect(() => {
    if (activeCard) {
      const hovered = document.querySelector('.hovered');
      if (hovered) {
        hovered.classList.remove('hovered');
      }
      const cardSvg = document.getElementsByClassName(`${activeCard}-svg`)[0];
      if (cardSvg) {
        cardSvg.classList.add('expand');
      }
    } else {
      const expandedSvg = document.getElementsByClassName('expand')[0];
      if (expandedSvg) {
        expandedSvg.classList.remove('expand');
      }
    }
  }, [activeCard]);

  const navigateToCard = (card) => () => {
    navigate(`/${card === 'projects' ? 'projects' : card}`);
  };

  const returnHome = () => {
    navigate('/');
  };

  const showDownloadButton = !(
    isCardOpen &&
    (location.pathname === '/projects' ||
      location.pathname === '/stats' ||
      location.pathname.startsWith('/projects/'))
  );

  return (
    <div className={isCardOpen ? 'App single-card' : 'App'}>
      {showDownloadButton && (
        <div className="cv-download-container">
          <a
            href="https://drive.google.com/uc?export=download&id=14PeEYwiIzC_ATln2hI7cEclF2xkjVW6c"
            rel="noopener noreferrer"
            target="_blank"
            download="AbdulAwalArif.pdf"
            className="cv-download-btn"
          >
            Download CV
          </a>
        </div>
      )}

      {!isCardOpen && (
        <CardContainer clickHandler={navigateToCard} />
      )}

      <Routes>
        <Route path="/about" element={<AboutPage returnBtn={returnHome} />} />
        <Route path="/projects" element={<ProjectsPage returnBtn={returnHome} />} />
        <Route path="/projects/:slug" element={<ProjectsPage returnBtn={returnHome} />} />
        <Route path="/stats" element={<ProjectsPage returnBtn={returnHome} initialTab="stats" />} />
        <Route path="/writings" element={<WritingsPage returnBtn={returnHome} />} />
        <Route path="/contact" element={<ContactsPage returnBtn={returnHome} />} />
        <Route path="/" element={null} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>

      <Svg1 />
      <Svg2 />
      <Svg3 />
      <Svg4 />
    </div>
  );
};

export default App;
